/**
 * "1 registro", "3 registros" (mapa de uso, 08/10/2026).
 *
 * Substitui o "registro(s)" que se espalhava pelas telas e pelas mensagens do
 * servidor: o "(s)" faz a frase parecer formulário. Mora aqui para a tela e o
 * servidor escreverem do mesmo jeito.
 */
export function plural(quantidade: number, um: string, varios: string): string {
  return `${quantidade.toLocaleString('pt-BR')} ${quantidade === 1 ? um : varios}`
}
